import { render, staticRenderFns } from "./m-block-set-organization.vue?vue&type=template&id=32ca4e6c&scoped=true&lang=pug&"
import script from "./m-block-set-organization.vue?vue&type=script&lang=js&"
export * from "./m-block-set-organization.vue?vue&type=script&lang=js&"
import style0 from "./m-block-set-organization.vue?vue&type=style&index=0&id=32ca4e6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ca4e6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
